const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNinjaOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(9.6, 9.6) scale(0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.960784%,21.960784%,33.725491%)",
      fillOpacity: 1
    },
    d: "M 3.601562 -0.0742188 L 44.101562 -0.0742188 C 46.164062 -0.0742188 47.851562 1.613281 47.851562 3.675781 L 47.851562 44.175781 C 47.851562 46.238281 46.164062 47.925781 44.101562 47.925781 L 3.601562 47.925781 C 1.539062 47.925781 -0.148438 46.238281 -0.148438 44.175781 L -0.148438 3.675781 C -0.148438 1.613281 1.539062 -0.0742188 3.601562 -0.0742188 Z M 3.601562 -0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.568628%,100%,53.333336%)",
      fillOpacity: 1
    },
    d: "M 32.324219 14.363281 C 30.710938 12.710938 28.574219 11.886719 25.914062 11.886719 C 23.25 11.886719 23.136719 12.148438 21.898438 12.636719 C 20.699219 13.164062 19.648438 13.875 18.863281 14.8125 L 18.863281 11.476562 L 12.9375 14.25 L 12.9375 34.199219 L 19.125 34.199219 L 19.125 23.4375 C 19.125 21.449219 19.574219 19.988281 20.511719 18.976562 C 21.449219 17.960938 22.6875 17.476562 24.226562 17.476562 C 25.761719 17.476562 26.699219 17.925781 27.449219 18.789062 C 28.199219 19.648438 28.574219 20.960938 28.574219 22.726562 L 28.574219 34.238281 L 34.761719 34.238281 L 34.761719 22.199219 C 34.761719 18.976562 33.9375 16.085938 32.324219 14.4375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaOne);
export default __webpack_public_path__ + "static/media/NinjaOne.8217d2ec9f80e81c9226af6f4290df46.svg";
export { ForwardRef as ReactComponent };